import ApiService from '@common/services/api.service'
import {useAuthStore} from '@common/store/auth'
//import i18n from '@common/services/i18n'
import debug from 'debug'
import {useMenuStore} from "@common/store/menu";
import {useDefinitionApplicationStore} from "@common/store/definition-application";
import router from '@common/router/router'

const tracer = debug('vue:portailService')

// Define the Portail type
interface PortailService {
    chargerConfiguration(): any;

    authentifier(methodeAuthentificationId: string, payload: object): any;

    rafraichirJeton(): any; // Optional method for refreshing the token
    deconnecter(params?: { invaliderJeton: boolean }): any;
}

export function getPortailService(): PortailService {
    return Portail;
}

export function setPortailService(portail: PortailService) {
    Portail = portail;
}

// Define the object
export const portailServiceCommun: PortailService = {


    async chargerConfiguration() {
        await ApiService.init();
        await useDefinitionApplicationStore().chargerDefinitionApplication();

        if (useAuthStore().estConnecte) {
            await useMenuStore().chargerMenu();
        }
    },


    async authentifier(methodeAuthentificationId, payload) {
        await useAuthStore().authentifier(methodeAuthentificationId, payload);

        console.log('appel de useMenuStore() Commun');

        await useMenuStore().chargerMenu();
        await router.push({path: '/'});
        await window.location.reload();
    },

    async rafraichirJeton() {
        try {
            await useAuthStore().rafraichirJeton();
        } catch (error) {
            console.error('Erreur lors du rafraîchissement du jeton:', error);
            throw error;
        }
    },

    async deconnecter({invaliderJeton}) {
        await useAuthStore().deconnecter({invaliderJeton});
        useMenuStore().viderMenu();
    }
};

let Portail: PortailService = portailServiceCommun;